<div class="w-100">
  <h1 class="head1">Notify Command</h1>
</div>
<div class="filter-wrap mb-3">
  <div class="filter-item">
    <label for="inputPassword6" class="col-form-label"
      >Search By<span class="text-danger">*</span></label
    >
  </div>
  <div class="filter-item">
    <input
      type="text"
      class="form-control w-200p"
      placeholder="Consumer ID/Device EUI"
      [(ngModel)]="keyword"
    />
  </div>
  <div class="filter-item">
    <button
      class="btn btn-primary-sa btn-sm mb-1 me-2 float-start"
      (click)="getDeviceId(keyword)"
    >
      Search
    </button>
    <button
      class="btn btn-primary-sa btn-sm mb-1 float-start"
      (click)="Clear()"
    >
      Clear
    </button>
  </div>
</div>
<div class="row">
  <div class="col-md-6 mb-3">
    <div class="card shadow-sm div1">
      <div class="row">
        <div class="col-md-5 pe-md-0">
          <div class="box-blue-fi">
            <p>Device Type</p>
            <p class="fw-600 font-15p mb-2">
              {{ device?.DeviceType?.type }}
            </p>
            <p>Consumer ID</p>
            <p class="fw-600 font-15p mb-2">{{ device?.consumer_id }}</p>
            <p>Dev EUI</p>
            <p class="fw-600 font-15p mb-2">{{ device?.dev_eui }}</p>
            <p>Usage Type</p>
            <p class="fw-600 font-15p mb-2">
              {{ device?.UsageType?.type }}
            </p>
            <p>Consumer Name</p>
            <p class="fw-600 font-15p mb-2">{{ device?.consumer_name }}</p>
            <p>Phone Number</p>
            <p class="fw-600 font-15p mb-2">
              {{
                device?.consumer_phone
                  ? "(" + device?.consumer_phone?.replace(",", ")")
                  : device
                  ? "-"
                  : ""
              }}
            </p>
            <p>Consumer Address</p>
            <p class="fw-600 font-15p mb-2">
              {{ device?.consumer_address }}
            </p>
            <p>Commission Date</p>
            <p class="fw-600 font-15p mb-2">
              {{ commissionDate }}
            </p>
            <p>Modified Date</p>
            <p class="fw-600 font-15p mb-2">
              {{ formattedModifiedDate }}
            </p>
            <p>Gateway Details</p>
            <p class="fw-600 font-15p mb-2">
              {{ device?.gateway_details }}
            </p>
          </div>
        </div>
        <div class="col-md-7 mb-3 px-5 px-md-4 py-4">
          <div class="row mb-2">
            <div class="col-md-6">
              <label for="inputPassword6" class="form-label"
                >Meter Readings</label
              >
            </div>
            <div class="col-md-6">
              <p class="font-15p m-0">
                <span class="font-10p"
                  >{{ device?.meter_reading }} Cubic Meter</span
                >
              </p>
            </div>
          </div>
          <div class="row mb-2">
            <div class="col-md-6">
              <label for="inputPassword6" class="col-form-label"
                >Set Meter Reading</label
              >
            </div>
            <div class="col-md-6">
              <input type="text" class="form-control" [(ngModel)]="meter" />
            </div>
          </div>
          <div class="row mb-4">
            <div class="col-md-6">
              <label for="inputPassword6" class="form-label"
                >Reporting Interval</label
              >
            </div>
            <div class="col-md-6">
              <p class="font-15p m-0">
                {{
                  device?.reporting_interval == 1440
                    ? "Daily"
                    : device?.reporting_interval == 60
                    ? "Hourly"
                    : device?.reporting_interval == 15
                    ? "Quarter-Hourly"
                    : ""
                }}
              </p>
            </div>
          </div>
          <div class="row mb-2">
            <div class="col-md-6">
              <label for="inputPassword6" class="col-form-label"
                >Set Reporting Interval</label
              >
            </div>
            <div class="col-md-6">
              <select name="" id="" class="form-select" [(ngModel)]="interval">
                <option value="1440">Daily</option>
                <option value="60">Hourly</option>
                <option value="15">Quarter-Hourly</option>
              </select>
            </div>
          </div>
          <div class="row mb-2">
            <div class="col-md-6">
              <label for="inputPassword6" class="col-form-label"
                >Set Time</label
              >
            </div>
            <div class="col-md-6">
              <div class="form-check mt-2">
                <input type="checkbox" class="form-check-input" [(ngModel)]="time" />
              </div>
            </div>
          </div>
          <div class="row mb-2">
            <div class="col-md-6">
              <label for="inputPassword6" class="col-form-label"
                >Reset Reverse Flow</label
              >
            </div>
            <div class="col-md-6">
              <div class="form-check mt-2">
                <input type="checkbox" class="form-check-input" [(ngModel)]="reverseflow" />
              </div>
            </div>
          </div>
          <div class="row mb-2">
            <div class="col-md-6">&nbsp;</div>
            <div class="col-md-6 text-end">
              <button class="btn btn-primary-sa btn-sm" (click)="downlink()">
                Submit
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="row">
  <div class="col-md-12">
    <div class="card px-3 py-4">
      <div class="filter-wrap">
        <div class="filter-item">
          <label for="inputPassword6" class="col-form-label"
            >Filter By Group</label
          >
          <select
            name="group-filter"
            id="group-filter"
            class="form-select"
            [(ngModel)]="selectedGroup"
            (change)="Search()"
          >
            <option value="all">All</option>
            <option *ngFor="let zone of zones" [value]="zone.id">
              {{ zone.name }}
            </option>
          </select>
        </div>
        <div class="filter-item float-xl-end me-0">
          <button class="btn btn-primary-sa btn-sm mb-2" (click)="exportCmds()">
            Export
          </button>
        </div>
      </div>
      <div class="table-scroll">
        <table width="100%" class="table table-striped">
          <thead>
            <tr>
              <th>Sr No</th>
              <th (click)="sortData('consumer_id')">
                Consumer ID
                <i
                  class="fas user-select-none"
                  [ngClass]="{
                    'fa-sort-up':
                      sortColumn === 'consumer_id' && sortOrder === 'ASC',
                    'fa-sort-down':
                      sortColumn === 'consumer_id' && sortOrder === 'DESC',
                    'fa-sort': sortColumn !== 'consumer_id'
                  }"
                ></i>
              </th>
              <th (click)="sortData('dev_eui')">
                Device EUI
                <i
                  class="fas user-select-none"
                  [ngClass]="{
                    'fa-sort-up':
                      sortColumn === 'dev_eui' && sortOrder === 'ASC',
                    'fa-sort-down':
                      sortColumn === 'dev_eui' && sortOrder === 'DESC',
                    'fa-sort': sortColumn !== 'dev_eui'
                  }"
                ></i>
              </th>
              <th (click)="sortData('cmd_sent_date')">
                Cmd time
                <i
                  class="fas user-select-none"
                  [ngClass]="{
                    'fa-sort-up':
                      sortColumn === 'cmd_sent_date' && sortOrder === 'ASC',
                    'fa-sort-down':
                      sortColumn === 'cmd_sent_date' && sortOrder === 'DESC',
                    'fa-sort': sortColumn !== 'cmd_sent_date'
                  }"
                ></i>
              </th>
              <th>Cmd status</th>
              <th>Send cmd</th>
              <th>Return cmd</th>
            </tr>
          </thead>
          <tbody>
            <tr
              *ngFor="
                let cmd of cmds
                  | paginate
                    : {
                        itemsPerPage: limit,
                        currentPage: page,
                        totalItems: totalRows
                      };
                index as i
              "
            >
              <td>{{ (page - 1) * limit + (i + 1) }}</td>
              <td>{{ cmd.consumer_id }}</td>
              <td>{{ cmd.Device?.dev_eui }}</td>
              <td>
                {{ (cmd.cmd_sent_date | date : "dd/MM/YY HH:mm:ss") ?? "-" }}
              </td>
              <td>{{ cmd.cmd_status }}</td>
              <td>{{ cmd.send_cmd ?? "-" }}</td>
              <td>{{ cmd.return_cmd ?? "-" }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <nav aria-label="Page navigation" class="pagenav-sa">
        <pagination-controls
          (pageChange)="pageChangeEvent($event)"
        ></pagination-controls>
      </nav>
    </div>
  </div>
</div>
